import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { organizationActions } from 'srcReact/OrganizationPage'
import Icon from '../../icons/Icon'

import styles from './styles.module.scss'
import Tile from 'srcReact/components/common2/Tile'

const FilterByWorkplace = ({
  current_organization,
  workplace_list,
  getWorkplaces,
  handleWorkplaceChange,
  allWorkplacesText,
  allWorkplacesInitial
}) => {
  const allWorkplaces = {
    name: allWorkplacesText,
    initials: allWorkplacesInitial,
    color: 'dark',
    id: '-1'
  }
  const [selectedWorkplace, setSelectedWorkplace] = useState(allWorkplaces)
  const [toggleMenu, setToggleMenu] = useState(false)

  useEffect(() => {
    if (current_organization && current_organization.info && current_organization.info.hasOwnProperty('resourceKey')) {
      getWorkplaces(current_organization.info.resourceKey)
    }
  }, [])

  const handleToggle = () => {
    setToggleMenu((isOpen) => !isOpen)
  }

  const handleChange = (workplace) => {
    setSelectedWorkplace(workplace)
    handleWorkplaceChange(workplace.id)
  }

  return (
    <div className={styles.container} onClick={handleToggle}>
      <h3 className={styles.selected}>
        <div className={styles.icon}>
          <Tile size='xSmall' className={`${styles.customTile} ${styles.iconSmall}`} color={selectedWorkplace.color}>
            {selectedWorkplace.initials}
          </Tile>
        </div>
        <Icon
          name='chevron-down'
          size='large'
          alt='chevron-down'
          styleModifier={`${toggleMenu ? styles.invertedChevron : ''}`}
        />
      </h3>

      {toggleMenu && (
        <div className={styles.menu} id='dropdown-workplace-menu'>
          <ul>
            <li className={styles.menuItem} onClick={() => handleChange(allWorkplaces)}>
              <div className={styles.icon}>
                <Tile size='xSmall' className={styles.customTile} color={allWorkplaces.color}>
                  {allWorkplaces.initials}
                </Tile>
              </div>
              <p className={styles.text}>{allWorkplaces.name}</p>
            </li>

            {workplace_list &&
              workplace_list.items &&
              workplace_list.items.length > 0 &&
              workplace_list.items.map((workplace) => (
                <li
                  key={workplace.id}
                  className={styles.menuItem}
                  data-value={workplace.id}
                  onClick={() => handleChange(workplace)}>
                  <div className={styles.icon}>
                    <Tile size='xSmall' className={styles.customTile} color={workplace.color}>
                      {workplace.initials}
                    </Tile>
                  </div>
                  <p className={styles.text}>{workplace.name}</p>
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  const {
    organization: { current_organization, workplace_list }
  } = state

  return { current_organization, workplace_list }
}

const actionCreators = {
  getWorkplaces: organizationActions.getWorkplaces
}

const ExtendedComponent = withTranslation('common')(FilterByWorkplace)

const connectedFilterByWorkplace = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedFilterByWorkplace as FilterByWorkplace }
